<div class="container">
  <div class="upgrade-container">
    <div class="image-bg" *ngIf="upgradeBanner && upgradeBanner?.image.length">
      <img [src]="upgradeBanner?.image[0]?.url" [alt]="upgradeBanner?.image[0]?.alternativeText" />
    </div>
    <div class="info-container">
      <div class="title">
        <div class="mobile-image-bg" *ngIf="upgradeBanner && upgradeBanner?.image.length">
          <img [src]="upgradeBanner?.image[0]?.url"
               [alt]="upgradeBanner?.image[0]?.alternativeText" />
        </div>
        <h4 class="heading"><adp-label labelKey="Dashboard_UpgradeBanner_Heading"></adp-label></h4>
      </div>
      <p class="subtitle"><adp-label labelKey="Dashboard_UpgradeBanner_SubTitle"></adp-label></p>
    </div>
    <!-- NOTE: we decided not to finish refactoring the UpgradeBanner component because the UpgradeBanner is only shown when the dealer code is PTPQA which only occurs for the PGH Organic portal which is an old portal. So no new portals will see this component so we don't have to worry about forgetting to set the properties up in the old Sitefinity, thus we don't have to refactor this. -->
    <a class="button-wrapper" [href]="upgradeBanner?.buttonLink" target="_blank">
      <button mat-flat-button color="accent"><adp-label labelKey="Dashboard_UpgradeBanner_ButtonText"></adp-label></button>
    </a>
  </div>
</div>
